
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/kamery",
      function () {
        return require("private-next-pages/[region]/kamery.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/kamery"])
      });
    }
  